import * as types from '../type'
import { merge} from 'service/utils'

const state = {
    constantCache : {},
    version : '',
}

const getters = {
    version: state =>state.version,
    constantCache: state => key =>{
        return (state.constantCache)[key]
    }
}

const actions = {
    set_version({commit}, data){
        commit(types.SETCONFIGVERSON, data)
    },
    set_constantCache({commit}, data){
        commit(types.SETCONFIGCONSTANTCACHE, data)
    }
}
const mutations = {
    [types.SETCONFIGVERSON](state, data){
        state.version = data
    },
    [types.SETCONFIGCONSTANTCACHE](state, data){
        state.constantCache = merge({},data)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/configData.js